module.exports = __webpack_public_path__ + "img/LATAM_HIGH_GLYCEMIC.41062e91.png";